import { useEffect, useState } from 'react';
import { Queue } from '@rossum/api-client/queues';
import {
  IconChevronDown,
  IconChevronUp,
  IconFolder,
} from '@rossum/ui/icons/tabler';
import {
  Collapse,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  SvgIcon,
  Typography,
} from '@rossum/ui/material';
import { WorkspaceWithQueues } from '../types';
import { Queue as QueueComponent } from './Queue';

type Props = {
  forceExpand: boolean;
  workspace: WorkspaceWithQueues;
  setSelectedQueue: (_queue: Queue) => void;
  selectedQueue: Queue | undefined;
};

export const Workspace = ({
  forceExpand,
  workspace,
  selectedQueue,
  setSelectedQueue,
}: Props) => {
  const [expanded, setExpanded] = useState(forceExpand);
  const toggleWorkspace = () => setExpanded(!expanded);

  useEffect(() => {
    setExpanded(forceExpand);
  }, [forceExpand]);

  return (
    <>
      <ListItemButton
        onClick={toggleWorkspace}
        data-cy={`workspace-menu-item-${workspace.name.replaceAll(' ', '-')}`}
      >
        <ListItemIcon sx={{ minWidth: theme => theme.spacing(4.5) }}>
          <SvgIcon fontSize="large" color="primary">
            <IconFolder />
          </SvgIcon>
        </ListItemIcon>
        <ListItemText
          primary={
            <Typography noWrap variant="body2">
              {workspace.name}
            </Typography>
          }
        />
        <SvgIcon fontSize="medium">
          {expanded ? <IconChevronUp /> : <IconChevronDown />}
        </SvgIcon>
      </ListItemButton>
      <Collapse in={expanded} mountOnEnter timeout="auto">
        <List component="div" disablePadding>
          {workspace.queues.map(queue => (
            <QueueComponent
              key={queue.id}
              onClick={() => setSelectedQueue(queue)}
              queueName={queue.name}
              selected={selectedQueue ? selectedQueue.url === queue.url : false}
            />
          ))}
        </List>
      </Collapse>
    </>
  );
};
